import React from "react";

const RecorderPauseIcon = props => {
  return (
    <svg
      width="32"
      height="32"
      {...props}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#3B82F6" />
      <path
        d="M12.3635 10.9102H14.5453V21.092H12.3635V10.9102ZM17.4544 21.092V10.9102H19.6363V21.092H17.4544Z"
        fill="#3B82F6"
      />
    </svg>
  );
};

export default RecorderPauseIcon;
